// ============================================================
//  Configuración única de los tableros (SLA, umbrales, agrupaciones de estado).
//  Cambiar acá impacta todos los dashboards — no replicar estos valores.
// ============================================================
import { Status } from './types';

/** N días: ventana "Próximo a vencer" (estado_entrega). */
export const SLA_PROXIMO_VENCER_DIAS = 3;

/** Antelación (deadline − solicitud) ≤ umbral ⇒ urgente por derivación (fallback). */
export const UMBRAL_URGENCIA_DIAS = 3;

/** Estados que cuentan como trabajo activo / backlog. */
export const ESTADOS_ACTIVOS: Status[] = ['pending', 'in_progress', 'paused'];

/** Estados que cuentan como entregado (denominador de cumplimiento). */
export const ESTADOS_ENTREGADOS: Status[] = ['done'];

/** Estados excluidos del volumen, carga, horas, ajustes y cumplimiento. */
export const ESTADOS_EXCLUIDOS_CARGA: Status[] = ['cancelled', 'rejected', 'pending_approval'];

export const esActivo = (s: string) => (ESTADOS_ACTIVOS as string[]).includes(s);
export const esEntregado = (s: string) => (ESTADOS_ENTREGADOS as string[]).includes(s);
export const esExcluido = (s: string) => (ESTADOS_EXCLUIDOS_CARGA as string[]).includes(s);

/** Etiquetas y colores del estado de entrega derivado. */
export const ESTADO_ENTREGA_LABELS: Record<string, string> = {
  adelantada: 'Entrega adelantada',
  a_tiempo: 'Entrega a tiempo',
  tarde: 'Entrega tarde',
  vencido: 'Vencido sin entregar',
  proximo: 'Próximo a vencer',
  en_curso: 'En curso',
  sin_deadline: 'Sin deadline',
  no_aplica: 'No aplica',
};

export const ESTADO_ENTREGA_COLORS: Record<string, string> = {
  adelantada: '#0891b2',
  a_tiempo: '#16a34a',
  tarde: '#dc2626',
  vencido: '#b91c1c',
  proximo: '#f59e0b',
  en_curso: '#2563eb',
  sin_deadline: '#94a3b8',
  no_aplica: '#cbd5e1',
};

export type EstadoEntrega = keyof typeof ESTADO_ENTREGA_LABELS;